<!-- <div class=" p-0 m-0">
  
</div> -->
<section id="home">
  <app-home ></app-home>
</section>
<section id="about">
  <app-about  [aboutMessage]="DATA?.about"></app-about>
</section>
<section id="skills">
  <app-skills [skills]="skills"></app-skills>
</section>
<section id="projects">
  <app-proyects [projects]="projects"></app-proyects>
</section>
<section id="experience">
  <app-experiences [experiences]="DATA?.experience"></app-experiences>
</section>
<section id="contact">
  <app-contact></app-contact>
</section>
<app-nav-bar [selected]="idSelected" [linksNavBar]="DATA?.navBar"></app-nav-bar>
